// src/admin/AdminRoute.tsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { supabase } from "../supabase/supabase";
import { isCurrentUserAdmin } from "../supabase/authService";

type Props = { children: React.ReactNode };

export default function AdminRoute({ children }: Props) {
  const [state, setState] = React.useState<"loading" | "allow" | "deny">("loading");
  const location = useLocation();

  React.useEffect(() => {
    let active = true;

    const check = async () => {
      try {
        const isAdmin = await isCurrentUserAdmin();
        if (active) setState(isAdmin ? "allow" : "deny");
      } catch {
        if (active) setState("deny");
      }
    };

    check();

    const { data } = supabase.auth.onAuthStateChange(() => {
      check();
    });

    return () => {
      active = false;
      data.subscription.unsubscribe();
    };
  }, []);

  if (state === "loading") return null; // burada bir Loader gösterebilirsiniz
  if (state === "deny") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
